import React from 'react';
import Card from 'react-bootstrap/Card';
import Col from 'react-bootstrap/Col';
import Row from 'react-bootstrap/Row';
import { FaGithub, FaLinkedin, FaResearchgate } from 'react-icons/fa';
import Button from 'react-bootstrap/Button';
import zahid from '../images/zahid.png';
import mayesha from '../images/mayesha.png';
import sani from '../images/sani.png';
import ashad from '../images/ashad.jpg';
import sir from '../images/sir.png';
import '../css/Members.css';
import GoToTopButton from '../pages/GoToTopButton';

const Members = () => {
  const cardData = [
    {
      image: zahid,
      title: "Md. Zahidul Islam, Id: 2022504",
      text: "Hello, my name is Zahidul Islam, and I am a computer science student. I love learning how computers work, how they interact with the human world, and what makes them tick.",
      github: 'https://github.com/zahidx',
      linkedin: 'https://www.linkedin.com/in/zahid-islam-53a33a202/',
      researchgate: 'https://www.researchgate.net/profile/Zahidul-Islam-54?ev=hdr_xprf&_sg=4qAX6bEN-I4TTximi_54tLmZu0b6NkYiP6MZkVu0JTax1dMhDtCqEPcXCVuFYPtaaUmNHixgPMZhl2k3wP-nWiMX',
    },
    {
      image: mayesha,
      title: " Kazi Mayesha Mehzabin, ID: 2022666",
      text: "A learning enthusiast who believes investing in learning. Incessant eagerness for sports, music, solving problems and anything that catches my eye.",
      github: 'https://github.com/Kazi-Mayesha-Mehzabin',
      linkedin: 'https://www.linkedin.com/in/kazi-mayesha-mehzabin-343197228',
      researchgate: 'https://www.researchgate.net/profile/Kazi-Mayesha-Mehzabin',
    },
    {
      image: sani,
      title: "Saniul Islam Sani, Id: 2022605",
      text: "Hello, my name is Saniul Islam Sani, and I'm a student in the Computer Science and Engineering department. In my free time, I enjoy playing games, reading books, and staying up to date on current affairs.",
      github: 'https://github.com/Sani1189',
      linkedin: 'https://www.linkedin.com/in/saniul-islam-sani-841898281',
      researchgate: 'https://www.researchgate.net/profile/Saniul-Islam-Sani',
    },
    {
      image: ashad,
      title: "Md. Ashaduzzaman Nur, Id: 1910397",
      text: "I am a dedicated and passionate research student, specializing in the field of medical image analysis and artificial intelligence (AI). With a keen interest in leveraging cutting-edge technologies to advance healthcare.",
      github: 'https://github.com/ashadnur71196',
      linkedin: 'https://www.linkedin.com/in/ashadnur711/',
      researchgate: 'https://www.researchgate.net/profile/Md-Ashaduzzaman-Nur-2',
    }
  ];

  return (
    <div className="main-class">
           
       <GoToTopButton />
      <div className="instructor-container">

        <div className="center-card">
          <div className="Team_members">
            <h1>Research Supervisor</h1>
          </div>
          <Card className="instructor-card">

            <Card.Img
              variant="top"
              src={sir}
              className="instructor-image"
              style={{
                width: '50%',
                height: 'auto',
                borderRadius: '10px',
                display: 'block',
                margin: '0 auto',
              }}
            />
            <Card.Body>
              <Card.Title>MOHAMMAD SHIDUJAMAN, PHD</Card.Title>
              <h6>Co-Director
                Human Computer Interaction Wing, CCDS
              </h6>
              <Card.Text>
                <p>Assistant Professor, SETS</p>
                <h6>Department of Computer Science & Engineering
                </h6>
                <p>
                  <a href="shidujaman@iub.edu.bd">shidujaman@iub.edu.bd</a>
                </p>
               <p>Research Area: Explainable AI and Robotics, HCI, HRI</p>
              </Card.Text>
              <Button variant="success" href="http://www.cse.iub.edu.bd/index.php/faculties/75">
                Explore more
              </Button>
            </Card.Body>
          </Card>
        </div>
      </div>

      <div className="member-sec">
        <div className="Team_members team-4">
          <h1>Team Members</h1>
        </div>
        <Row xs={1} md={2} className="g-4">
          {cardData.map((data, idx) => (
            <Col key={idx}>
              <div>
                <Card className="custom-card">
                  <Card.Img
                    variant="top"
                    src={data.image}
                    className="card-image"
                    style={{
                      width: '30%',
                      height: 'auto',
                      borderRadius: '50%',
                      display: 'block',
                      margin: '0 auto',
                    }}
                  />
                  <Card.Body>
                    <Card.Title className="card-title">{data.title}</Card.Title>
                    <Card.Text className="card-text">
                      {data.text}
                      <div className="btn-follow">
                        <Button
                          variant="success"
                          style={{
                            color: '#fff',
                            border: 'none',
                            borderRadius: '7px',
                            cursor: 'pointer',
                            fontSize: '1rem',
                            fontWeight: 'bold',
                            margin: '15px 0 0 0',
                            width: '28%',
                          }}
                        >
                          Follow On
                        </Button>
                      </div>
                      <div className="icon-links">
                        <a href={data.github} target="_blank" rel="noopener noreferrer">
                          <FaGithub />
                        </a>
                        <a href={data.linkedin} target="_blank" rel="noopener noreferrer">
                          <FaLinkedin />
                        </a>
                        <a href={data.researchgate} target="_blank" rel="noopener noreferrer">
                          <FaResearchgate />
                        </a>
                      </div>
                    </Card.Text>
                  </Card.Body>
                </Card>
              </div>
            </Col>
          ))}
        </Row>
      </div>
    </div>
  );
};

export default Members;
